import { render } from "./HomeView.vue?vue&type=template&id=2985ec66&ts=true"
import script from "./HomeView.vue?vue&type=script&lang=ts"
export * from "./HomeView.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__